import React, { Component } from 'react';
import ItemsEdit from '../Shared/Items/ItemsBooleanDefault';
import { DownloadButton } from '../../../../utils/download';
import { UploadArea } from '../../../../utils/upload';

import {
    stepExclusionSchema,
} from '@swa_llow/pricing_engine';

class ExclusionsEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            upload: false,
        }
        this.uploadedExclusions = this.uploadedExclusions.bind(this);
    }

    uploadedExclusions(results) {
        const { step } = this.props;
        this.setState({ upload: false });
        this.props.updateStep({
            ...step,
            items: results,
        });
    }

    render() {
        const { 
            selected_item_id,
            step,
            inputs,
            is_approved,
            errors,
            version,
        } = this.props;

        const { upload } = this.state;

        const { items = [] } = step;
        const count = items.length;

        return (
            <div>
                <div className="inputs-upload">
                    <div key={`full-buttons`} className="upload-buttons">
                        <button className="button small grey no-hover mr">Count : {count}</button>
                        <DownloadButton 
                            data={{
                                items,
                            }}
                            label={'Exclusions'}
                            file_name={`${step.key}.csv`}
                            type={'items'}
                            className={'mr'}
                        />
                        {!is_approved && <button className="button small secondary" onClick={() => this.setState({ upload: !this.state.upload })}>
                            <i className="fa fa-angles-up"></i>Upload Exclusions
                        </button>}
                    </div>
                    {upload &&
                        <div className="exclusions-edit">
                            <UploadArea
                                complete={this.uploadedExclusions}
                                type='items' 
                            />
                        </div>
                    }
                </div>
                <ItemsEdit
                    version={version}
                    schema={stepExclusionSchema}
                    set_error={this.props.set_error}
                    updateStep={this.props.updateStep}
                    errors={errors}
                    step={step}
                    inputs={inputs}
                    header={'Exclusions'}
                    description={'This section allows you to create a list of exclusions reasons (i.e. why you will not provide a price or premium to a quote).'}
                    tag={'Exclusion'}
                    is_approved={is_approved}
                    selected_item_id={selected_item_id}
                />
            </div>
        );
    }
}

export default ExclusionsEdit;